import { APP_ROUTES } from "../constants";

export const getScanHistoryPageUrl = (id: string): string => {
  return `${APP_ROUTES.private_routes.sources}/${id}/scan_history`;
};
